import { useMutation } from "@apollo/client";
import { CREATE_COMPANY_DOCUMENT_CONFIRMATION } from "../api/create-company-document-confirmation-mutation";
import { FieldsType } from "./types";
import { GET_READ_UNREAD_PERSONS } from "@/modules/documents/widgets/company-document-statistic/api/get-read-unread-persons";

export function useCreateCompanyDocumentConfirmation({
  afterSubmit,
}: { afterSubmit?: () => void } = {}) {
  const [createConfirmation, { loading }] = useMutation(
    CREATE_COMPANY_DOCUMENT_CONFIRMATION,
    {
      refetchQueries: [GET_READ_UNREAD_PERSONS],
    },
  );

  const create = async (variables: FieldsType) => {
    await createConfirmation({
      variables,
    });

    afterSubmit?.();
  };

  return {
    create,
    loading,
  };
}
